import { createReducer } from '@reduxjs/toolkit';

import { loadSiteDetailsStart, loadSiteDetailsSuccess, resetSiteDetails } from './actions';
import { ISiteReducer } from './types';

const initialState: ISiteReducer = {
  details: null,
  detailsLoading: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadSiteDetailsStart, (state) => ({
      ...state,
      detailsLoading: true,
    }))
    .addCase(loadSiteDetailsSuccess, (state, action) => ({
      ...state,
      details: action.payload,
      detailsLoading: false,
    }))
    .addCase(resetSiteDetails, (state) => ({
      ...state,
      details: initialState.details,
    }));
});
